import React, { useContext, useEffect } from 'react';
import { slide as Menu } from 'react-burger-menu';
import FocusLock from 'react-focus-lock';
import PropTypes from 'prop-types';
import { Link as GatsbyLink } from 'gatsby';

import { Context } from '../../Providers/Blade';
import Portal from '../Portal';

import { Overlay, Header, Body, Logo, CloseBtn, Wrapper } from './styles';
// * Children {react els} Elements that get rendered inside the body of the blade
// * isOpen {bool} to track when the blade is open
// * title {string} used as the id for the blade
// * logo {string} the src of the logo
function Blade({ children, isOpen, title, logo, logoSharp }) {
  const { resetState, closeAllMenusOnEsc } = useContext(Context);

  // * Force all blade menus closed on mount
  useEffect(() => resetState(), []);

  return (
    <Portal>
      <FocusLock>
        <Wrapper
          id={`outer-container-${title.split(' ').join('-')}`}
          isOpen={isOpen}
        >
          <Overlay isOpen={isOpen} onClick={() => resetState()} />
          <Menu
            right
            noOverlay
            as="div"
            htmlClassName="blade-is-open"
            className={isOpen ? 'is-active' : ''}
            customBurgerIcon={false}
            customCrossIcon={false}
            isOpen={isOpen}
            customOnKeyDown={closeAllMenusOnEsc}
            outerContainerId={`outer-container-${title.split(' ').join('-')}`}
          >
            <Header>
              <GatsbyLink to="/">
                <Logo src={logoSharp.publicURL} alt={logo.altTag} />
              </GatsbyLink>
              <CloseBtn aria-label="close" onClick={() => resetState()} />
            </Header>
            <Body>{children}</Body>
          </Menu>
        </Wrapper>
      </FocusLock>
    </Portal>
  );
}

Blade.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  logo: PropTypes.shape(),
  logoSharp: PropTypes.shape(),
  isOpen: PropTypes.bool,
  title: PropTypes.string,
};

Blade.defaultProps = {
  children: null,
  title: 'Menu',
  logo: null,
  logoSharp: null,
  isOpen: false,
};

export default Blade;
